import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { DocumentCreate } from '../../services';

export const fetchDocumentCreate = createAsyncThunk(
    'documentCreate/fetchDocumentCreate',
    async ({ file, title, slug, description, content, sort }) => {
        const response = await DocumentCreate(file, title, slug, description, content, sort)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const documentCreateSlice = createSlice({
    name: 'documentCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDocumentCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDocumentCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchDocumentCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default documentCreateSlice.reducer;
